import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * Founder UAT — shared accessible password field with show/hide toggle.
 * Masked by default; toggling never alters the value; keyboard accessible.
 * Forwards every native prop so autofill / password managers keep working.
 */
export const PasswordInput = React.forwardRef(function PasswordInput(
  { className, 'data-testid': testId, ...props }, ref,
) {
  const { i18n } = useTranslation();
  const isES = (i18n.language || 'es').toLowerCase().startsWith('es');
  const [visible, setVisible] = useState(false);
  const label = visible
    ? (isES ? 'Ocultar contraseña' : 'Hide password')
    : (isES ? 'Mostrar contraseña' : 'Show password');
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={cn('pr-10', className)}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={label}
        title={label}
        aria-pressed={visible}
        tabIndex={0}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-r-md"
        data-testid={testId ? `${testId}-toggle` : 'password-visibility-toggle'}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
